import React from 'react';
import { Link } from 'react-router-dom';
// import { siteConfig } from '../../config.js';

// export default function({ collapsed, styling }) {
export default function () {
  return (
    <div className="isoLogoWrapper">
      <h3>
        <Link to="/dashboard">
          <img
            style={{ display: 'block', marginTop: 21 }}
            alt="Clearfront HR Logo"
            src={`${process.env.PUBLIC_URL}/images/navigationLogo.svg`}
            height={30}
          />
        </Link>
      </h3>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/utility/logo.js